export default "__VITE_ASSET__BIm25__H__"